import { COLORS } from '../const/colors';

const { ACTIVE_CIRCLE_COLOR, INACTIVE_CIRCLE_COLOR, CONNECT_FROM_COLOR } = COLORS;

export const circleBGColor = (
  connectFrom, circleId, activeCircleIndex, circleIndex, currentActiveCircle,
) => {
  if (connectFrom === circleId) {
    return CONNECT_FROM_COLOR;
  }
  if (currentActiveCircle === circleId) {
    return ACTIVE_CIRCLE_COLOR;
  }
  return INACTIVE_CIRCLE_COLOR;
};
